import { render } from "./cis.cattle.io.clusterscanprofile.vue?vue&type=template&id=56976b1e"
import script from "./cis.cattle.io.clusterscanprofile.vue?vue&type=script&lang=js"
export * from "./cis.cattle.io.clusterscanprofile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__